import {useCallback, useState} from 'react'
import {Modal, Button} from 'react-bootstrap'
import {Form, Formik} from 'formik'
import * as Yup from 'yup'
import TextInput from '../../widgets/components/Input/TextInput'
import {useIntl} from 'react-intl'
import '../styles/InvestorCrm.scss'
// import {CiMinimize1, CiMaximize1} from 'react-icons/ci'
import {addColumn, editColumn, getAllColumnsFromRoundIdIU} from '../core/_requests'
import {ToolTipUI} from '../../widgets/components/UI/ToolTipUI'
// import {GET_FILE_URL} from '../../investor-database/core/_requests'
import {toast} from 'react-toastify'
import {useShortScale} from '../../../hooks/useShortScale'
import {DateTime, Interval} from 'luxon'
import {DisplayImage} from '../../widgets/components/General/DisplayImage'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import Skeleton from 'react-loading-skeleton'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import {useAuth} from '../../auth'

export const CurrentRound = ({
  activeRound,
  setModalShow,
  show,
  setShow,
  selectedRoundId,
  setGetAllColumns,
  columnDetails,
  setColumnsDetails,
  setIsEditRound,
  editRound,
  commitedInvestors,
  initialLoading,
}: any) => {
  const [color, setColor] = useState<any>()
  const [loading, setLoading] = useState(false)
  const {convertValueToShortScale} = useShortScale()
  const [collapseCRM, setCollapseCRM] = useState(true)
  const {currentUser, companyId} = useAuth()

  const initialValues = {
    name: '',
  }

  const columnNameSchema = Yup.object().shape({
    name: Yup.string().required('Column Name is required'),
  })
  const {formatMessage} = useIntl()
  const colorArray = ['#383940', '#4776E6', '#1BC5BD', '#F64E60', '#50BEE8']

  const calculateDateDifference = (inputDateStr: any) => {
    const inputDate = DateTime.fromISO(inputDateStr)
    const currentDate = DateTime.now()

    const interval = Interval.fromDateTimes(inputDate, currentDate)
    const duration = interval.toDuration(['months', 'days']).toObject()

    const months = duration.months || 0
    const days = duration.days || 0
    return `${Math.floor(months)} Mo ${Math.floor(days)} Days`
  }

  //done
  const onSubmit = useCallback(
    async (values: any) => {
      setLoading(true)
      const column: any = {}
      column['columnName'] = values.name
      if (!color) {
        column['color'] = columnDetails.color
      } else {
        column['color'] = color
      }
      if (columnDetails?.columnId) {
        column['columnId'] = columnDetails.columnId

        try {
          const {
            data: {success, errors},
          } = await editColumn(column)
          if (success) {
            setLoading(false)
            toast.success(formatMessage({id: 'Column edited successfully'}))
            if (selectedRoundId) {
              const {
                data: {success, data: allColumns},
              } = await getAllColumnsFromRoundIdIU(selectedRoundId)
              if (success) {
                setGetAllColumns(allColumns)
                setShow(false)
              }
            }
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CRMEditColumnSuccessful,
                action: 'normal',
                metadata: {
                  column_name: values.name || '',
                  column_id: columnDetails.columnId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                },
              },
            })
          } else {
            setLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CRMEditColumnFailed,
                action: 'normal',
                metadata: {
                  column_name: values.name || '',
                  column_id: columnDetails.columnId,
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                  error: errors[0],
                },
              },
            })
          }
        } catch (error) {
          setLoading(false)
          console.log(error)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMEditColumnFailed,
              action: 'normal',
              metadata: {
                column_name: values.name || '',
                column_id: columnDetails.columnId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: error,
              },
            },
          })
        }
      } else {
        column['roundId'] = parseInt(selectedRoundId)
        try {
          const {
            data: {success, errors},
          } = await addColumn(column)
          if (success) {
            setLoading(false)
            toast.success(formatMessage({id: 'Column added successfully'}))
            if (selectedRoundId) {
              const {
                data: {success, data: allColumns},
              } = await getAllColumnsFromRoundIdIU(selectedRoundId)
              if (success) {
                setGetAllColumns(allColumns)
                setShow(false)
              }
            }
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CRMAddColumnSuccessful,
                action: 'normal',
                metadata: {
                  column_name: values.name || '',
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                },
              },
            })
          } else {
            setLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({id: error}))
            })
            TagManager.dataLayer({
              dataLayer: {
                event: GTMEvent.CRMAddColumnFailed,
                action: 'normal',
                metadata: {
                  column_name: values.name || '',
                  user_id: currentUser?.userId,
                  email: currentUser?.email,
                  company_id: companyId,
                  error: errors[0],
                },
              },
            })
          }
        } catch (error) {
          setLoading(false)
          console.log(error)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.CRMAddColumnFailed,
              action: 'normal',
              metadata: {
                column_name: values.name || '',
                user_id: currentUser?.userId,
                email: currentUser?.email,
                company_id: companyId,
                error: error,
              },
            },
          })
        }
      }
    },[columnDetails, color, selectedRoundId, setShow, setGetAllColumns, formatMessage] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const investorImg: string[] = []
  activeRound?.allInvestors.forEach((investor: any) => {
    if (investor.file !== null) {
      investorImg.push(investor?.file?.name)
    }
  })

  // const addRound = () => {
  //   setColumnsDetails({})
  //   setIsEditRound(false)
  //   setModalShow(true)
  // }
  return (
    <>
      <div className='accordion container-fluid' id='parent-accordion2'>
        <div className='row'>
          <div className='col-md-12'>
            <div className='accordion-item row'>
              <h2 className='accordion-header parent-accordion' id='panelsStayOpen-headingCRM'>
                <button
                  className={`accordion-button row px-5 py-md-3 py-4 crm-accordian-main ${
                    collapseCRM ? 'hideIt' : ''
                  }`}
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#panelsStayOpen-collapseCRM'
                  aria-expanded='true'
                  aria-controls='panelsStayOpen-collapseCRM'
                  onClick={() => {
                    setCollapseCRM(!collapseCRM)
                  }}
                >
                  <div className='col-md-3 col-12 gap-2 d-flex align-items-center'>
                    {loading || initialLoading ? (
                      <>
                        <div className='w-25'>
                          <Skeleton
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='w-50'>
                          <Skeleton
                            height={35}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 className='text-dark fs-md-3 fs-6 mb-0'>
                          {formatMessage({id: activeRound?.roundName})}
                        </h4>
                        <h4>
                          <span className='badge badge-secondary rounded-1 active-round-badge text-primary px-4 py-3 mt-2'>
                            {formatMessage({id: 'Ongoing'})}
                          </span>
                        </h4>
                      </>
                    )}
                  </div>
                  <div className='col-md-3 col-12 c-profile_list py-2 position-relative mb-2 mb-md-0'>
                    {/* {investorImage.map((image) => (
                      <img
                        src={image}
                        alt='profilepic'
                        height='36px'
                        width='36px'
                        className='c-profile'
                      />
                    ))} */}
                    {loading || initialLoading ? (
                      <div className='d-flex'>
                        {Array(4)
                          .fill(null)
                          .map((_, index) => (
                            <Skeleton
                              width={36}
                              height={36}
                              baseColor='var(--kt-skeleton-bg-color)'
                              highlightColor='var(--kt-skeleton-highlight-bg-color)'
                            />
                          ))}
                      </div>
                    ) : (
                      <>
                        {commitedInvestors.slice(0, 4).map((item: any) => (
                          <DisplayImage
                            imgName={item?.file}
                            alt='profile'
                            fit='contain'
                            className='c-profile'
                            onClickPath={`/investor-database/profile/${item?.investorUserId}`}
                          />
                        ))}
                        {commitedInvestors.length - 4 > 0 && (
                          <>
                            {/* <img
                            src={toAbsoluteUrl('/media/icons/duotune/general/more_user.svg')}
                            alt='profilepic'
                            height='36px'
                            width='36px'
                            className='c-profile'
                          />
                          <span className='extra-count-text text-center'>
                            +{commitedInvestors.length - 4}
                          </span> */}
                            <div
                              className='extra-count-text-container'
                              style={{position: 'relative', display: 'inline'}}
                            >
                              <img
                                src={toAbsoluteUrl('/media/icons/duotune/general/more_user.svg')}
                                alt='profilepic'
                                height='36px'
                                width='36px'
                                className='c-profile '
                              />
                              <span className='position-absolute top-50 start-50 translate-middle extra-count-text'>
                                +{commitedInvestors.length - 4}
                              </span>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>

                  <div className='col-md-5 col-12 d-flex crm-progress flex-column'>
                    {loading || initialLoading ? (
                      <Skeleton
                        height={36}
                        baseColor='var(--kt-skeleton-bg-color)'
                        highlightColor='var(--kt-skeleton-highlight-bg-color)'
                      />
                    ) : (
                      <>
                        {' '}
                        <div className='d-flex justify-content-between' style={{color: '#8898A6'}}>
                          <div className=' mb-2 '>
                            <div className='fw-semibold '>
                              {activeRound?.currency?.symbol}
                              {convertValueToShortScale(activeRound?.amountAchieved)} <span> </span>{' '}
                              of {activeRound?.currency?.symbol}
                              {convertValueToShortScale(activeRound?.amountTargeted)}{' '}
                            </div>
                          </div>
                          <span className='align-self-end mb-2 fw-semibold'>
                            <small>
                              {Math.ceil(
                                (activeRound?.amountAchieved /
                                  parseInt(activeRound?.amountTargeted)) *
                                  100
                              )}
                              %
                            </small>
                          </span>
                        </div>
                        <div className='col-md-10 h-6px progress  w-100'>
                          <div
                            className='progress-bar bg-primary'
                            role='progressbar'
                            style={{
                              width: `${Math.ceil(
                                (activeRound?.amountAchieved /
                                  parseInt(activeRound?.amountTargeted)) *
                                  100
                              )}%`,
                            }}
                          ></div>
                        </div>
                      </>
                    )}
                  </div>
                </button>
              </h2>
              <div
                id='panelsStayOpen-collapseCRM'
                className='accordion-collapse collapse'
                aria-labelledby='panelsStayOpen-headingCRM'
                data-bs-parent='#parent-accordion2'
              >
                <div className='accordion-body row gap-md-3  d-flex justify-content-between crm-accordian-list px-5 py-0 pt-2'>
                  <div className='col-md-2 col-6'>
                    {loading || initialLoading ? (
                      <>
                        <div className='mb-1'>
                          <Skeleton
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mb-md-5 mb-2'>
                          <Skeleton
                            height={15}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 className='fs-md-5 fs-5 fw-semibold'>
                          {calculateDateDifference(activeRound.createdAt)}
                        </h4>
                        <p className='fs-md-8 fs-6'>{formatMessage({id: 'Round Age'})}</p>
                      </>
                    )}
                  </div>
                  <div className='col-md-2 col-6'>
                    {loading || initialLoading ? (
                      <>
                        <div className='mb-1'>
                          <Skeleton
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mb-2'>
                          <Skeleton
                            height={15}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 className='fs-md-5 fs-5 fw-semibold'>{activeRound?.roundType}</h4>
                        <p className='fs-md-8 fs-6'>{formatMessage({id: 'Round Type'})}</p>
                      </>
                    )}
                  </div>
                  <div className='col-md-2 col-6'>
                    {loading || initialLoading ? (
                      <>
                        <div className='mb-1'>
                          <Skeleton
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div className='mb-2'>
                          <Skeleton
                            height={15}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 className='fs-md-5 fs-5 fw-semibold'>
                          {activeRound?.currency?.symbol}{' '}
                          {convertValueToShortScale(activeRound?.amountTargeted)}
                        </h4>
                        <p className='fs-md-8 fs-6'>{formatMessage({id: 'Targeted'})}</p>
                      </>
                    )}
                  </div>
                  <div className='col-md-2 col-6'>
                    {loading || initialLoading ? (
                      <>
                        <div className='mb-1'>
                          <Skeleton
                            height={20}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                        <div>
                          <Skeleton
                            height={15}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <h4 className='fs-md-5 fs-5 fw-semibold'>
                          {activeRound?.currency?.symbol}{' '}
                          {convertValueToShortScale(activeRound?.amountAchieved)}
                        </h4>
                        <p className='fs-md-8 fs-6'>{formatMessage({id: 'Achieved'})}</p>
                      </>
                    )}
                  </div>
                  <div className=' col-md-3 col-12 d-flex justify-content-center'>
                    {loading || initialLoading ? (
                      <div className='w-100 w-md-50 mb-5'>
                        <Skeleton
                          height={35}
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </div>
                    ) : (
                      <button
                        className='text-light btn bg-primary font-size-13 height-36 d-flex align-items-center mb-4 w-md-75 w-100 justify-content-center'
                        onClick={editRound}
                      >
                        {formatMessage({id: 'Edit Round'})}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={() => setShow(false)}>
        <Formik
          initialValues={initialValues}
          validationSchema={columnNameSchema}
          onSubmit={onSubmit}
          validateOnMount
        >
          {(formik) => {
            initialValues.name = columnDetails?.columnName
            return (
              <Form
                className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                id='kt_login_password_reset_form'
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    {columnDetails?.columnId
                      ? formatMessage({id: 'Edit Column'})
                      : formatMessage({id: 'Add New Column'})}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <TextInput
                    fieldType={'name'}
                    fieldName={'name'}
                    formik={formik}
                    placeholder={''}
                    label={formatMessage({id: 'Column Name'})}
                    toolTipText={formatMessage({id: 'GLOBAL.TOOLTIP.INVESTOR.COLUMNAME'})}
                  />
                  <div>
                    <label className='form-label'>{formatMessage({id: 'Column Color'})}</label>
                    <ToolTipUI
                      tooltipText={formatMessage({id: 'GLOBAL.TOOLTIP.INVESTOR.COLUMNCOLOR'})}
                    />
                    <div className='col-5 color-input d-flex justify-content-around'>
                      {colorArray &&
                        colorArray.map((item) => (
                          <button
                            key={item}
                            className='red border-0'
                            type='button'
                            style={{
                              backgroundColor: item,
                              height: '25px',
                              width: '25px',
                              borderRadius: '59px',
                            }}
                            onClick={() => {
                              setColor(item)
                              setColumnsDetails({...columnDetails, color: item})
                            }}
                          >
                            {columnDetails?.color === item && (
                              <i className='fa-check fa-solid fs-5 my-0 py-1 text-white'></i>
                            )}
                          </button>
                        ))}
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant='secondary' onClick={() => setShow(false)}>
                    {formatMessage({id: 'Cancel'})}
                  </Button>

                  <Button variant='primary' type='submit' disabled={!formik.isValid || loading}>
                    {!loading ? (
                      <>{formatMessage({id: 'Save'})}</>
                    ) : (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        {formatMessage({id: 'Please wait...'})}{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </Button>
                </Modal.Footer>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </>
  )
}
